export const MESSAGES = {
  UPLOAD: {
    FILE_SELECTED: "File selected for upload",
    STARTED: "Upload started...",
    COMPLETED: "Upload processing completed successfully.",
    FAILED: "Upload failed. Please try again.",
    RESPONSE: "Upload response: ",
  },

  EDIT: {
    SAVED: "Edit changes saved successfully.",
    FAILED: "Failed to save edit changes.",
    DATA: "Edited data: ",
  },

  DOCX_PREVIEW: {
    ZOOM_IN_LABEL: "Zoom In",
    ZOOM_OUT_LABEL: "Zoom Out",
    ZOOM_SELECT_LABEL: "Select zoom level",
    AUTOMATIC_ZOOM_LABEL: "Automatic Zoom",
    ACTUAL_SIZE_LABEL: "Actual Size",
    PAGE_FIT_LABEL: "Page Fit",
    PAGE_WIDTH_LABEL: "Page Width",
    HIGHLIGHT_LABEL: "Highlight",
    DELETE_HIGHLIGHT_LABEL: "Remove highlight",
    PRINT_LABEL: "Print",
    DOWNLOAD_LABEL: "Download",
    ROTATE_LEFT_LABEL: "Rotate Left",
    ROTATE_RIGHT_LABEL: "Rotate Right",
  },

  EXTRACTION: {
    COMPLETED: "Extraction processing completed successfully.",
    CONTINUE_WARNING:
      "Issues were found in some transcripts. Resolve them to include all transcripts in evaluation.",
  },

  WEBSOCKET: {
    CLOSED_CLEAN: "WebSocket closed cleanly: ",
    CLOSED_UNEXPECTED: "WebSocket closed unexpectedly.",
    FIXED_MESSAGE_SENT: "Fixed message sent to the server.",
    HANDSHAKE_STOPED: "WebSocket not open, stopping interval.",
    UPLOAD_HANDSHAKE_MESSAGE: "Hello from client",
    EXTRACTION_HANDSHAKE_MESSAGE: "Hello from client credit Evaluation",
    COURSE_MATCHING_HANDSHAKE_MESSAGE: "Hello from client final",
    HANDSHAKE_TYPE: "chat",
    BACKEND_MESSAGE: "Backend message received: ",
    ONOPEN_ERROR: "Error sending data via WebSocket: ",
    ONMESSAGE_ERROR: "Error parsing WebSocket message: ",
    ERROR: "WebSocket encountered an error: ",
  },

  EVALUATION: {
    STARTED: "Evaluation started...",
    COMPLETED: "Evaluation completed successfully.",
    FAILED: "Evaluation failed. Please try again.",
    RESPONSE: "Evaluation response: ",
    ALL_COURSES_LABEL: "All",
    ELIGIBLE_FOR_TRANSFER_LABEL: "Eligible for Transfer",
    NOT_ELIGIBLE_FOR_TRANSFER_LABEL: "Not Eligible for Transfer",
    SELECT_COURSE:
      "Are you sure you want to include this course for transfer credit? It will move forward to the Equivalency stage for review.",
    REMOVE_COURSE:
      "Are you sure you want to remove this course from transfer credit? It will not proceed to the Equivalency stage",
    CONTINUE_WARNING:
      "Some transcripts do not contain any courses selected for transfer. Only transcripts with selected courses will be processed for equivalency. If you need to include those transcripts, please select courses for them before proceeding.",
  },

  COURSE_MATCHING: {
    RESPONSE: "Course matching response: ",
    APPROVE_MESSAGE: "Approved Successfully",
    REJECT_MESSAGE: "Rejected Successfully",
    AI_SUMMARY_REQUIRED_FOR_PRE_EVALUATION:
      "AI Summary must be completed before generating the pre-evaluation report.",
  },

  COURSE_PICKER: {
    DEFAULT_STATUS: "Search by course code, name...",
    SEARCHING_STATUS: "Searching...",
    SEARCH_LABEL: "Search or Add New Course",
    SEARCH_PLACEHOLDER: "Search or Add New",
    SEARCH_ERROR_TOAST: "Failed to fetch course search results",
    SEARCH_ERROR_STATUS: "Failed to fetch course search results. Please try again.",
    NO_RESULTS_HELPER: "No match found, add as a new course",
    ADD_NEW_BUTTON: "Add New Course",
    DIALOG_TITLE: "Add New Course",
    COURSE_CODE_LABEL: "Course Code",
    COURSE_NAME_LABEL: "Course Name",
    COURSE_CODE_REQUIRED: "Course code is required.",
    COURSE_NAME_REQUIRED: "Course name is required.",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_BUTTON: "Add Course",
    INVALID_FORMAT_TOAST:
      "Invalid format. Please use the following format: 'code - course name'",
    INVALID_FORMAT_STATUS:
      "Couldn't add the course. Try again in the format: 'code - course name'",
    EMPTY_NAME_TOAST:
      "Invalid input. Course name cannot be empty. Please use the format: 'code - course name'",
    EMPTY_NAME_STATUS: "Couldn't add the course. Course name cannot be empty.",
    EXISTS_STATUS: "This course already exists.",
    ADDED_STATUS: "Course added",
  },

  FEEDBACK: {
    POPUP_ERROR: "FeedbackComponent not found in template!",
    REJECT_MESSAGE: "Reject popup logic here...",
    CANCEL_CONFIRM:
      "Are you sure to cancel the feedbacks and mark the session as completed.",
  },

  SESSION: {
    KEY: "Session Key: ",
  },

  MODAL: {
    STARTOVER_TITLE: "Start Over",
    STARTOVER_MESSAGE:
      "Are you sure you want to start over? This will clear all progress.",
    STARTOVER_BUTTONTEXT: "Start Over",
    REJECT_TITLE: "Reject Transcript",
    REJECT_MESSAGE: "Are you sure you want to reject this transcript?",
    REJECT_BUTTONTEXT: "Reject",
    APPROVE_TITLE: "Approve Transcript",
    APPROVE_MESSAGE: "Are you sure you want to approve this transcript?",
    APPROVE_BUTTONTEXT: "Approve",
  },

  RETRY: {
    CONFIRM_MESSAGE:
      "We’re having trouble completing this step right now. This could be due to a temporary system or network issue. Please try again in a moment.",
    RETRY_COMPLETED:
      "Retry of all transcripts are completed. Closing WebSocket...",
    RETRY_NOT_REQUIRED: "All sessions are completed. No retry required.",
    RETRY_REQUIRED: "Some outputs are missing. Retrying websocket...",
    RETRY_FAILED:
      "We’re having trouble completing this step right now. Please try again in a moment. If the issue persists, please contact your admin for assistance.",
  },
};
